import React from "react";

import Button, { ButtonProps } from "../../button/Button";
import { MarkOutdated } from "../../svg/svgImageList";

export default function MarkOutdatedButton(props: ButtonProps) {
  const { disabled, tooltipKey: tooltip, onClick } = props;

  return (
    <Button
      id="mark-outdated"
      disabled={disabled}
      onClick={onClick}
      tooltipKey={tooltip}
      icon={{
        svg: MarkOutdated,
        textKey: "general.inspection.relevance.mark-outdated",
        textClass: "actions-header-button-label",
      }}
    />
  );
}
